module.exports = __webpack_public_path__ + "static/media/wallfinishes_gwp_60yd_y.552ef7a7.csv";